import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MOurService } from '../../molecules';

export default function OIndustrialServices({ className }) {
	return (
		<article className={`layout-body--xl o-section-our-service ${className}`}>
			<h2 className="m-our-service-title">
				<FormattedMessage id="INDUSTRIAL.OUR_SERVICE" defaultMessage="" />
			</h2>

			<div className="m-our-service--wrapper">
				<MOurService
					title="INDUSTRIAL.OUR_SERVICE_DESIGN_TITLE"
					description="INDUSTRIAL.OUR_SERVICE_DESIGN_DESCRIPTION"
					type="left"
				/>
				<MOurService
					title="INDUSTRIAL.OUR_SERVICE_RENT_TITLE"
					description="INDUSTRIAL.OUR_SERVICE_RENT_DESCRIPTION"
					type="right"
				/>
			</div>
		</article>
	);
}

OIndustrialServices.propTypes = {
	className: PropTypes.string,
};
OIndustrialServices.defaultProps = {
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/industrial/_organisme.industrial-services.js